export * from './TextatorSplashScreen';
